/** 工地地图共用地址处理：施工备注留在项目标题中，导航只传实际街址。
 * 历史坐标可能是整条路/邮编中心，未经本次门牌核对的坐标不能用来导航。
 */
export const cleanMapAddress = (address) => String(address || "")
  .replace(/\([^)]*\)|（[^）]*）/g, " ")
  .replace(/\b(Rd|Dr|Ave|St|Blvd)(?=[A-Z][a-z])/g, "$1, ")
  .replace(/\b(HOUSE ADDITION|FRONT YARD|BACK YARD|ADDITION|REMODEL|NEW ADU)\b/gi, " ")
  .replace(/\s+/g, " ").replace(/^[ ,]+|[ ,]+$/g, "");

export const validCoordinates = (p) => p?.lat != null && p?.lng != null && p.lat !== "" && p.lng !== ""
  && Number.isFinite(Number(p.lat)) && Number.isFinite(Number(p.lng))
  && Math.abs(Number(p.lat)) <= 90 && Math.abs(Number(p.lng)) <= 180;

/** 导航优先使用已核对的标准地址；这样入口/路线不受旧库错误经纬度影响。 */
export const navigationDestination = (p) => encodeURIComponent(cleanMapAddress(p?.locationAddress || p?.address)
  || (validCoordinates(p) ? `${p.lat},${p.lng}` : ""));

export const projectNavigationUrl = (p) => `https://www.google.com/maps/dir/?api=1&destination=${navigationDestination(p)}`;
